/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import { Trans } from "app/utils";
import StoryPromptSlider from "components/stories/StoryPromptSlider";
import { useIsLoggedIn, useIsMobile } from "app/hooks";
import PromptSelector from "./PromptSelector";
import StoryInstructions from "./StoryInstructions";
import PostStoryButtons from "./PostStoryButtons";
import PostStoryMedia from "./PostStoryMedia";
import PostStoryEditor from "./PostStoryEditor";
import { usePostStoryContext } from "../../contexts/PostStoryContext";

const PostStoryLeftColumn = () => {
  const isLoggedIn = useIsLoggedIn();
  const isMobile = useIsMobile();
  const {
    state: {
      selectedPrompt,
      selectedMedia,
      showUnsplashSearch
    },
    handleUserAnswers,
    onUpdateStory,
    onDeleteStory
  } = usePostStoryContext();

  return (
    <div className="LeftColumn">
      <div>
        <PromptSelector />
        {selectedPrompt?.summary && <StoryInstructions />}
        <PostStoryButtons />
      </div>

      {isMobile && (
        <>
          {(!!selectedMedia || showUnsplashSearch) && <PostStoryMedia />}
          <div className={showUnsplashSearch ? "hidden" : "visible"}>
            <PostStoryEditor />
          </div>
        </>
      )}
      <div className="Responses-Container">
        <h3 className="Responses-Title">
          <Trans>EXAMPLE STORIES FOR THIS PROMPT</Trans>
        </h3>
        <StoryPromptSlider
          isPublic={!isLoggedIn}
          storyQuestion={selectedPrompt}
          onDeleteStory={onDeleteStory}
          onUpdateStory={onUpdateStory}
          onUserAnswers={handleUserAnswers}
        />
      </div>
    </div>
  );
};

export default PostStoryLeftColumn;
